import { LocalizationProvider as MuiLocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { deDE as deDEDatePicker, enUS as enUSDatePicker } from "@mui/x-date-pickers/locales";
import type { PickersInputLocaleText } from "@mui/x-date-pickers/locales";
import type { JSX, ReactNode } from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type DatePickerLanguage = {
  adapterLocale: string;
  localeText: PickersInputLocaleText;
};

const getDatePickerLanguage = (language?: string): DatePickerLanguage => {
  if (language?.startsWith("en")) {
    return {
      adapterLocale: "en-US",
      localeText: enUSDatePicker.components.MuiLocalizationProvider.defaultProps.localeText,
    };
  }

  return {
    adapterLocale: "de-DE",
    localeText: deDEDatePicker.components.MuiLocalizationProvider.defaultProps.localeText,
  };
};

type LocalizationProviderProps = {
  children?: ReactNode;
};

export const LocalizationProvider = ({ children }: LocalizationProviderProps): JSX.Element => {
  const { i18n } = useTranslation();
  const datePickerLanguage = useMemo(() => getDatePickerLanguage(i18n.language), [i18n.language]);

  return (
    <MuiLocalizationProvider
      dateAdapter={AdapterLuxon}
      // Define the date locale to have the right format `day.month.year`.
      adapterLocale={datePickerLanguage.adapterLocale}
      // Define the translations to have the right placeholders (e.g. `JJJJ` for the year).
      localeText={datePickerLanguage.localeText}
    >
      {children}
    </MuiLocalizationProvider>
  );
};
